import { PlanType } from '../constants/plan';
import { getBackVersion } from '../config';
import {
    InvoiceSnapshot,
    InvoiceTierSnapshot,
    PricingSnapshot,
    InvoiceValuesSnapshot,
} from '../models/Billing';
import api, { rawClient } from './api';

const getInvoices = () => {
    return api.request<InvoiceSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/invoices`,
    });
};

const getInvoice = (invoiceId: string) => {
    return api.request<InvoiceSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/invoices/${invoiceId}`,
    });
};

const payInvoiceWithRentalBalance = (invoiceId: string) => {
    return api.request<InvoiceSnapshot>({
        method: 'PATCH',
        url: `${getBackVersion()}/invoices/${invoiceId}`,
    });
};

const getInvoiceDetails = (
    invoiceId: string
): Promise<InvoiceTierSnapshot[]> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/invoices/${invoiceId}/details`,
    });
};

const getInvoiceValues = (
    invoiceId: string
): Promise<InvoiceValuesSnapshot> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/invoices/${invoiceId}/values`,
    });
};

const getPricing = (planType?: PlanType): Promise<PricingSnapshot[]> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/pricing`,
        params: {
            // eslint-disable-next-line camelcase
            plan_type: planType,
        },
    });
};

const downloadInvoicePdf = (invoiceId: string): Promise<void> => {
    return rawClient.download({
        method: 'GET',
        url: `${getBackVersion()}/invoices/${invoiceId}/pdf`,
    });
};

type BalanceLimit = {
    limit: number;
};

const getBalanceLimit = (): Promise<BalanceLimit> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/invoices/limit`,
    });
};

const getCurrentInvoice = () => {
    return api.request<InvoiceSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/invoices/current`,
    });
};

export default {
    getInvoice,
    getInvoices,
    getInvoiceDetails,
    getInvoiceValues,
    downloadInvoicePdf,
    getPricing,
    getCurrentInvoice,
    getBalanceLimit,
    payInvoiceWithRentalBalance,
};
